import { render, staticRenderFns } from "./HospitalReporting.vue?vue&type=template&id=6ba36de7"
import script from "./HospitalReporting.vue?vue&type=script&lang=js"
export * from "./HospitalReporting.vue?vue&type=script&lang=js"
import style0 from "./HospitalReporting.vue?vue&type=style&index=0&id=6ba36de7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports